import { TablePagination } from '@material-ui/core';
export const PaginationTable = ({ page,count,rowsPerPage, props}) => {
  return (
    <div>
        <TablePagination
        {...props}
          count={count?.length}
          page={page}
          rowsPerPage={rowsPerPage}
          component="div"
        />
    </div>
  );
}